import React, { useState } from 'react';
import imgVectorStroke from '../../assets/sections/e9abf0ec4a717184e499ca220b6cc5d3646bc0a7.svg';
import imgEllipse2 from '../../assets/sections/33da542f2e3e500464f76528948cb9dd63728177.svg';
import imgGroup17 from '../../assets/sections/4b092af9b6cfa5000fdd07da2ffe4c4499f08f44.svg';

const FAQ_ITEMS = [
  {
    question: 'Sự kiện này có mất phí không?',
    answer: 'Không, sự kiện hoàn toàn miễn phí. Tất cả các hoạt động trong chuỗi sự kiện TopCV tại Hải Phòng đều mở cửa cho tất cả mọi người tham gia mà không tốn bất kỳ chi phí nào.',
  },
  {
    question: 'Sự kiện có giới hạn số lượng người tham dự không?',
    answer: 'Có, số lượng chỗ ngồi có giới hạn tại một số hoạt động như Webinar và Company Tour. Bạn nên đăng ký sớm để đảm bảo suất tham gia của mình.',
  },
  {
    question: 'Sự kiện dành cho ai?',
    answer: 'Sự kiện dành cho sinh viên, người đang tìm kiếm việc làm và ứng viên có quan tâm đến thị trường lao động tại Hải Phòng. Mọi ngành nghề đều được chào đón.',
  },
  {
    question: 'Tôi có cần đăng ký để tham gia không?',
    answer: 'Có, bạn cần đăng ký trước để chúng tôi có thể chuẩn bị tốt nhất cho sự kiện. Vui lòng điền vào form đăng ký trên website hoặc quét mã QR để đăng ký tham gia.',
  },
  {
    question: 'Làm sao để biết tôi đã đăng ký thành công?',
    answer: 'Sau khi đăng ký thành công, bạn sẽ nhận được email xác nhận gửi đến địa chỉ email bạn đã cung cấp. Bạn cũng có thể kiểm tra trong Zalo Group của sự kiện để biết thêm thông tin.',
  },
];

function AccordionItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="content-stretch flex flex-col overflow-clip relative rounded-[16px] shrink-0 w-full cursor-pointer"
      data-name="Background+Shadow"
      onClick={() => setOpen(prev => !prev)}
    >
      <div aria-hidden="true" className="absolute bg-[rgba(0,46,42,0.1)] inset-0 pointer-events-none rounded-[16px]" />
      {/* Header row */}
      <div className="flex items-center justify-between px-[56px] py-[40px] relative w-full">
        <p className="font-['Alexandria',sans-serif] font-normal leading-[33px] relative shrink-0 text-[24px] text-white">
          {question}
        </p>
        <div
          className="overflow-clip relative shrink-0 size-[32px] transition-transform duration-300"
          style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}
        >
          <div className="absolute inset-[34.37%_17.71%_34.38%_17.71%]">
            <img alt="" className="absolute block max-w-none size-full" src={imgVectorStroke} />
          </div>
        </div>
      </div>
      {/* Expandable answer */}
      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{ maxHeight: open ? '300px' : '0px', opacity: open ? 1 : 0 }}
      >
        <p className="font-['Alexandria',sans-serif] font-normal leading-[33px] px-[56px] pb-[40px] text-[22px] text-white/70">
          {answer}
        </p>
      </div>
      <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_14px_10px_222px_0px_rgba(0,177,79,0.2)]" />
    </div>
  );
}

export default function QnA() {
  return (
    /* No fixed height — section grows with accordion content */
    <div className="relative w-[1921px] overflow-hidden" data-node-id="237:856-qna">
      {/* Full-bleed dark background */}
      <div className="absolute bg-[#012e2a] inset-0 left-[-37px] w-[1995px]" data-name="image 7" data-node-id="237:857" />

      {/* Glow decoration — purely visual, doesn't affect flow */}
      <div className="absolute h-[430px] left-[574px] top-[650px] w-[835px] pointer-events-none" data-node-id="237:970">
        <div className="absolute inset-[-159.07%_-81.92%]">
          <img alt="" className="block max-w-none size-full" src={imgEllipse2} />
        </div>
      </div>

      {/* Content in normal flow — pushes section height */}
      <div className="relative z-10 flex flex-col items-center w-full pt-[100px] pb-[120px]">

        {/* Title */}
        <p
          className="font-['Alexandria',sans-serif] font-bold leading-[normal] text-[#e9fffa] text-[56px] uppercase whitespace-nowrap mb-[60px]"
          data-node-id="237:933"
        >
          QNA
        </p>

        {/* Accordion list */}
        <div className="flex flex-col gap-[18px] w-[1017px]" data-node-id="237:977">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem key={i} question={item.question} answer={item.answer} />
          ))}
        </div>

        {/* Separator decoration — sits below the last accordion in flow */}
        <div className="relative h-0 w-[356px] mt-[80px]" data-node-id="237:935">
          <div className="absolute inset-[-48px_-13.48%]">
            <img alt="" className="block max-w-none size-full" src={imgGroup17} />
          </div>
        </div>

      </div>
    </div>
  );
}
